export const headerStyles = 'flex flex-col gap-3';
export const accountCard = 'rounded bg-background-light text-background-color p-7';
export const borderClasses = 'border-b-[3px] border-b-accent pb-1';
